// Fallback for non-iOS platforms
const ExpoOpticalMeasureModule = {
  isSupported(): boolean {
    return false
  },
}

export default ExpoOpticalMeasureModule
